import { isAxiosError } from "axios";
import axiosInstance from "../../utility/axiosInstance";

// types and state
import {
  setCollege,
  updateCollege,
  deleteCollege,
  setLoading,
} from "../../store/slices/college";
import { openNotification } from "../../components/ui/alerts";

export const get_colleges = async (dispatch: Function) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get("/get-colleges");

    dispatch(setCollege(response.data));
  } catch (error) {
    dispatch(setCollege([]));
  }
  dispatch(setLoading());
};

export const create_college = async (
  dispatch: Function,
  data: { name: string },
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post("/create-college", data);

    dispatch(updateCollege(response.data?.data));
  } catch (error) {
    // dispatch(setRole([]));
  }
  dispatch(setLoading());
};

export const delete_college = async (
  dispatch: Function,
  id: string | number,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.delete(`/delete-college/${id}`);

    dispatch(deleteCollege(id));
    openNotification({
      message: response?.data?.message || "College deleted successfully",
      status: "success",
    });
  } catch (error) {
    if (isAxiosError(error)) {
      openNotification({
        message: error?.response?.data?.message || "Failed to delete college",
        status: "error",
      });
    }
  }
  dispatch(setLoading());
};
